
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 90"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"115","height":"89","x":".5","y":".5","fill":"#FFF","stroke":"#E0E4EC","rx":"4"}}),_c('path',{attrs:{"fill":"#C1C8D6","d":"M50.267 51L39 62.626v4.879L42.49 69l6.649-5.714L56 56.646z"}}),_c('path',{attrs:{"fill":"#0C3454","d":"M46.803 38.825h-6.882v2.7h6.758a20.565 20.565 0 002.493 8.6l-10.722 10.8a5.007 5.007 0 00-1.446 3.725A5.543 5.543 0 0042.34 70h.15a4.98 4.98 0 003.565-1.45l10.897-10.825a20.081 20.081 0 0022.971-2.19 20.209 20.209 0 005.816-22.388C82.793 25.2 75.207 19.947 66.75 20c-10.536.08-19.23 8.286-19.948 18.825zm-2.643 27.8a2.241 2.241 0 01-1.745.675 2.821 2.821 0 01-2.718-2.725 2.253 2.253 0 01.673-1.75l6.21-6.225a24.814 24.814 0 003.865 3.725l-6.284 6.3zm8.204-8.2a21.993 21.993 0 01-3.865-3.75l2.269-2.175a20.998 20.998 0 003.69 3.7l-2.094 2.225zm14.387-.75c-9.64 0-17.454-7.835-17.454-17.5s7.814-17.5 17.454-17.5 17.455 7.835 17.455 17.5-7.815 17.5-17.455 17.5z"}}),_c('path',{attrs:{"fill":"#05B5E4","d":"M81.981 41.193h-6.789l-1.867-2.977L67.495 50l-4.618-13.506-2.726 4.7h-8.075a11.696 11.696 0 010-2.658h6.385L63.508 30l4.442 12.989 5.047-10.308 3.66 5.855h5.198c.067.44.11.884.126 1.329.025.442.025.886 0 1.328z"}}),_c('path',{attrs:{"fill":"#00B7E9","d":"M46.679 41.525c0-.9.041-1.8.124-2.7h-6.882v2.7h6.758z"}})])])
          )
        }
      }
    